<template>
  <SimpleModuleDashboard
    :module-id="Modules.INFORME_COBRANZAS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="dashboardActions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({ Modules, Profiles }),
  computed: {
    isSeller() {
      return !!Helper.getSeller()
    },
    dashboardActions() {
      return this.isSeller
        ? [
          { id: 'crudReportSeller', reference: 'crudReportSeller', route: 'ReportsPaymentStaffCrudReportSeller', tone: 'primary' },
          { id: 'mobileSurrenderCreate', reference: 'mobileSurrenderCreate', route: 'ReportsPaymentStaffMobileSurrenderCreate', tone: 'success' },
          { id: 'crudSurrenderSeller', reference: 'crudSurrenderSeller', route: 'ReportsPaymentStaffCrudSurrenderSeller', tone: 'secondary' },
        ]
        : [
          { id: 'crudReport', reference: 'crudReport', route: 'ReportsPaymentStaffCrudReport', tone: 'primary' },
          { id: 'crudSurrender', reference: 'crudSurrender', route: 'ReportsPaymentStaffCrudSurrender', tone: 'secondary' },
        ]
    },
  },
}
</script>
